import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import formReducer from "../json-form/formSlice";

// reducers
const reducer = {
  form: formReducer
}

// middlewares
const middleware = [
  ...getDefaultMiddleware()
]

// add logger to middleware
if (process.env.NODE_ENV !== 'production') {
  middleware.push(logger);
}

// devtools
const devTools = process.env.NODE_ENV !== 'production';

// preloaded state
const preloadedState = {

}

// configure store
export const store = configureStore({ reducer, middleware, devTools, preloadedState });
